import { Observable, of } from 'rxjs';
import { PunchoutBuildContext, PunchoutOrderRow, PunchoutPayload, PunchoutProtocol } from '../../../models/punchout';

/**
 * Base class every punchout mapper extends. The `identifier` is the value the
 * admin picks in the punchout config dropdown — it must be globally unique
 * across all registered handlers, and it is what gets stored on
 * `PunchoutCustomerConfig.qualifier` so the runtime can re-resolve the same
 * mapper on the next session.
 *
 * To add a customer-specific mapper, see the registration example in
 * `punchout.module.ts` (search for "PUNCHOUT_PROTOCOL_HANDLERS").
 */
export abstract class PunchoutProtocolHandler {
  abstract readonly protocol: PunchoutProtocol;
  abstract readonly identifier: string;
  abstract readonly label: string;

  // one-shot async setup, awaited before buildPayload so mapRow can stay synchronous
  prepare(): Observable<void> {
    return of(undefined);
  }

  abstract buildPayload(rows: PunchoutOrderRow[], context?: PunchoutBuildContext): PunchoutPayload;

  getFormFields(payload: PunchoutPayload): { name: string; value: string }[] {
    if (payload.kind === 'oci-form-post') {
      return Object.entries(payload.fields).map(([name, value]) => ({ name, value }));
    }
    if (payload.kind === 'cxml-form-post') {
      return [{ name: 'cxml-urlencoded', value: payload.xmlBody }];
    }
    return [];
  }
}
